import { ProjectSuperStatusBase } from './base/project-super-status-base';

export class ProjectSuperStatus extends ProjectSuperStatusBase { }